import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { Router } from '@angular/router';
import { CancelCall, PhoneCallCustomer } from '../../models/call';
import { PhonecallService } from '../phonecall.service';
import { CustomerService } from '../../customers/customer.service';
import { CallerNameModalComponent } from '../caller-name-modal/caller-name-modal.component';

@Component({
  selector: 'app-incoming-call-modal',
  templateUrl: './incoming-call-modal.component.html',
  styleUrls: ['./incoming-call-modal.component.less']
})
export class IncomingCallModalComponent {
  readonly nzModalData: { call: PhoneCallCustomer } = inject(NZ_MODAL_DATA);

  constructor(private modalRef: NzModalRef, private router: Router, private phonecallService: PhonecallService, private customerService: CustomerService, private modalService: NzModalService) {}

  openCustomer(): void {
    const cancelCall: CancelCall = {
      callId: this.nzModalData.call.phoneCallId,
      clientId: this.nzModalData.call.clientId
    };
    this.phonecallService.handleCall(cancelCall).subscribe();
    this.customerService.pendingCallId = this.nzModalData.call.phoneCallId;
    this.router.navigate(['/customer', this.nzModalData.call.customerId]);
    this.modalRef.destroy();
  }

  handleCall(): void {
    const cancelCall: CancelCall = {
      callId: this.nzModalData.call.phoneCallId,
      clientId: this.nzModalData.call.clientId
    };
    this.phonecallService.handleCall(cancelCall).subscribe();
    this.modalRef.destroy();

    const phoneNumber = this.nzModalData.call.phoneNumber;
    const nameModalRef = this.modalService.create({
      nzTitle: 'Caller Name',
      nzContent: CallerNameModalComponent,
      nzFooter: null,
      nzMaskClosable: false,
      nzClosable: true,
      nzWidth: 400,
      nzData: { phoneNumber }
    });

    nameModalRef.afterClose.subscribe((customerName: string | null) => {
      this.customerService.pendingCallPhoneNumber = phoneNumber;
      this.customerService.pendingCallCustomerName = customerName ?? null;
      this.customerService.pendingCallId = this.nzModalData.call.phoneCallId;
      this.router.navigate(['/search']);
    });
  }

  dismiss(): void {
    this.modalRef.destroy();
  }
}
